import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_TASK_TYPE,
  FETCH_TASK_TYPE_MODE,
  FETCH_TASK_TYPE_MODE_CLEAR,
  CHANGE_TASK_TYPE_STATUS,
  CHANGE_TASK_TYPE_STATUS_SUCCESS,
  CHANGE_TASK_TYPE_STATUS_FAILURE,
  SAVE_TASK_TYPE,
} from "./actionTypes";
import * as types from './actionTypes';
import {
  fetchTaskType,
  fetchTaskTypeSuccess,
  fetchTaskTypeFailure,
  fetchTaskTypeMode,
  fetchTaskTypeModeSuccess,
  fetchTaskTypeModeFailure,
  fetchTaskTypeModeClear,
  changeTaskTypeStatus,
  changeTaskTypeStatusSuccess,
  changeTaskTypeStatusFailure,
  saveTaskTypeSuccess,
  saveTaskTypeFailure,
} from "./actions";
import { get, post, update, del } from "../../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Task Type
function* fetchTaskTypeSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_TASK_TYPE, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve module!");
    }
    yield put(fetchTaskTypeSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchTaskTypeFailure(error.message));
  }
}

function* fetchTaskTypeModeSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_FETCH_TASK_TYPE_MODE_DROPDOWN, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve client service dropdown data!");
    }
    yield put(fetchTaskTypeModeSuccess(response)); 
  } catch (error) {
    console.error("Saga API Error:", error); 
    yield put(fetchTaskTypeModeFailure(error.message));
  }
}

function* fetchTaskTypeModeClearSaga(action) {
  fetchTaskTypeModeClear();
}

function* changeTaskTypeStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_CHANGE_TASK_TYPE_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_TASK_TYPE_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_TASK_TYPE_STATUS_FAILURE, payload: error });
  }
}

// Create Task Type Saga
function* saveTaskTypeSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_TIMESHEET_SETUP_SAVE_TASK_TYPE, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Task Type saved successfully!",
      });
      yield put(saveTaskTypeSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchTaskType(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(saveTaskTypeFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the deduction",
    });
    yield put(saveTaskTypeFailure(error.message));
  }
}

// Watcher Saga
function* timesheetSetupTaskTypeSaga() {
  yield takeEvery(FETCH_TASK_TYPE, fetchTaskTypeSaga);  
  yield takeEvery(FETCH_TASK_TYPE_MODE, fetchTaskTypeModeSaga); 
  yield takeEvery(FETCH_TASK_TYPE_MODE_CLEAR, fetchTaskTypeModeClearSaga);
  yield takeEvery(CHANGE_TASK_TYPE_STATUS, changeTaskTypeStatusSaga);
  yield takeEvery(SAVE_TASK_TYPE, saveTaskTypeSaga);
}

export default timesheetSetupTaskTypeSaga;
